var render = function render(){var _vm=this,_c=_vm._self._c;return _c('piece-card',{attrs:{"title":"僧众动态"}},[_c('div',{staticClass:"buddhist-body"},[_c('chart',{staticClass:"chart-box",attrs:{"option":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }